// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5d941efa","667":"aa19e560","977":"ffcaf20f"}[chunkId] + ".chunk.js";
};